import { Suspense, useState } from 'react';

import { DirectUrlScrapingList } from './DirectUrlScrapingList';
import { GoogleSearchScrapingList } from './GoogleSearchScrapingList';

import { PageHeader } from '@/shared/components/page-header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/components/shadcn/tabs';

export function ScrapingPage() {
  const [activeTab, setActiveTab] = useState('keywords');

  return (
    <div>
      <PageHeader title="Scraping" />
      <Tabs value={activeTab} onValueChange={setActiveTab} className="p-3">
        <TabsList className="grid grid-cols-2">
          <TabsTrigger value="keywords">Google Search</TabsTrigger>
          <TabsTrigger value="urls">URLs</TabsTrigger>
        </TabsList>
        <TabsContent value="keywords">
          <Suspense fallback={null}>
            <GoogleSearchScrapingList />
          </Suspense>
        </TabsContent>
        <TabsContent value="urls">
          <Suspense fallback={null}>
            <DirectUrlScrapingList />
          </Suspense>
        </TabsContent>
      </Tabs>
    </div>
  );
}
